import { useEffect, useRef, useState } from "react";
import { useSite } from "../../context/SiteContext";

export const useFx = () => ({ particles: true, glow: true, countup: true, ...(useSite().site?.effects || {}) });

const DOTS = Array.from({ length: 22 }, (_, i) => ({
  left: (i * 37) % 100, size: 2 + ((i * 7) % 4), delay: (i * 0.9) % 9, dur: 9 + ((i * 5) % 8),
}));

export const Particles = ({ testid = "fx-particles" }) => {
  const { particles } = useFx();
  if (!particles) return null;
  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden data-testid={testid}>
      {DOTS.map((d, i) => (
        <span key={i} className="fx-dot" style={{ left: `${d.left}%`, width: d.size, height: d.size, animationDelay: `${d.delay}s`, animationDuration: `${d.dur}s` }} />
      ))}
    </div>
  );
};

export const CountUp = ({ value, prefix = "", suffix = "", testid }) => {
  const { countup } = useFx();
  const target = Number(String(value).replace(/[^\d.]/g, ""));
  const isNum = String(value).trim() !== "" && !Number.isNaN(target);
  const [n, setN] = useState(countup && isNum ? 0 : target);
  const ref = useRef();

  useEffect(() => {
    if (!countup || !isNum) { setN(target); return; }
    let raf;
    const io = new IntersectionObserver(([e]) => {
      if (!e.isIntersecting) return;
      io.disconnect();
      const t0 = performance.now();
      const step = (t) => {
        const p = Math.min(1, (t - t0) / 1600);
        setN(target * (1 - Math.pow(1 - p, 3)));
        if (p < 1) raf = requestAnimationFrame(step);
      };
      raf = requestAnimationFrame(step);
    }, { threshold: 0.3 });
    if (ref.current) io.observe(ref.current);
    return () => { io.disconnect(); cancelAnimationFrame(raf); };
  }, [countup, isNum, target]);

  const shown = isNum ? Math.round(n).toLocaleString("en-IN") : value;
  const final = `${prefix}${isNum ? target.toLocaleString("en-IN") : value}${suffix}`;
  return (
    <span ref={ref} data-testid={testid}>
      <span aria-hidden>{prefix}{shown}{suffix}</span>
      <span className="sr-only">{final}</span>
    </span>
  );
};
